module.exports = __webpack_public_path__ + "static/media/ruffles-crunch-teen-burger-dt-en.1938293f.jpg";